import React from "react";

interface CellBooleanProps {
  value?: boolean;
}

export const CellBoolean: React.FC<CellBooleanProps> = ({ value }) => {
  return <span children={value ? "Yes" : "No"} />;
};
